module.exports = __webpack_public_path__ + "img/dodatni_vir_ogenj_inactive.png";